import { render, staticRenderFns } from "./goodsSafeSet.vue?vue&type=template&id=0076d5f0&scoped=true&"
import script from "./goodsSafeSet.vue?vue&type=script&lang=js&"
export * from "./goodsSafeSet.vue?vue&type=script&lang=js&"
import style0 from "./goodsSafeSet.vue?vue&type=style&index=0&id=0076d5f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0076d5f0",
  null
  
)

component.options.__file = "goodsSafeSet.vue"
export default component.exports